import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M20 10c0-4.234-3.582-8-8-8s-8 3.766-8 8v.548c0 5.07 4.762 9.375 6.938 11.078a1.71 1.71 0 0 0 2.124 0C15.238 19.923 20 15.618 20 10.548z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    }, null, -1)
  ])))
}
export default { render: render }